import socialeMediaApi from "../../../api/socialeMediaApi";
import * as messages from "../../../constants/ToastrConstants";
import { showToastrError, showToastrSuccess, showToastrWarning } from "../../../util/toastr";
import mergeDeep from "../../../util/mergeDeep";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";

import assign from 'object-assign';

export default class SocialeMediaPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const params = context.props.match.params;
        const transactieId = params.transactieId;
        const isNew = context.props.isNew;
        const disabled = context.props.disabled;

        ajaxActions.started();
        if (transactieId) {
            socialeMediaApi.get(transactieId, isNew)
                .then((response) => {
                    ajaxActions.ended();
                    this.processModel(response.data, {}, '', false);
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    context.props.throwException(ex, true);
                });
        }

        context.setState({
            transactieId
        });
    }

    save() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const params = context.props.match.params;
        const transactieId = params.transactieId;

        let errors = null;
        let model = null;

		const modelToSave = { transactionId: transactieId, model: this.context.state.model};

        ajaxActions.started();
        return socialeMediaApi.save(modelToSave).then((response) => {
            ajaxActions.ended();
            let hasUnsavedChanges = this.context.hasUnsavedChanges;
            let validationMessageType;
            if (response.statusText === "OK" && !response.data.hasValidationErrors) {
                if (Object.keys(response.data.validationResults).length !== 0) {
                    model = assign({}, response.data.item);
                    errors = assign({}, response.data.validationResults);
                    showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS);
                    showToastrSuccess(messages.MESSAGE_SAVED);
                }
                else {
                    model = assign({}, response.data.item, {});
                    errors = {};
                    showToastrSuccess(messages.MESSAGE_SAVED);
                }
                hasUnsavedChanges = false;
                validationMessageType = ValidationMessageTypes.WARNING;
                this.processModel(model, errors, validationMessageType, hasUnsavedChanges);
            } else {
                errors = assign({}, response.data.validationResults);
                model = assign({}, response.data.item, {});
                showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
                validationMessageType = ValidationMessageTypes.ERROR;
                this.context.setState({
                    errors,
                    validationMessageType,
                    shouldScrollToFirstError: true
                });
            }
        })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    processModel(response, validationResults, validationMessageType, hasUnsavedChanges) {
        const context = this.context;
        let errors = validationResults;

        const tabSettings = response.tabSettings;
        context.props.setTabSettings(tabSettings);

        if (response.transactionId)
            context.props.setActiveTransaction(response.transactionId);

        context.setState({
            originalModel: mergeDeep({}, response.model),
            model: response.model,
            errors,
            validationMessageType,
            shouldScrollToFirstError: true,
            hasUnsavedChanges: hasUnsavedChanges
        });
        context.props.setHasUnsavedChanges(hasUnsavedChanges);
    }

    change(event, inputmask) {
        const value = event.target.value;
        const property = event.target.name;

        const model = this.context.state.model;
        model[property] = inputmask && value ? inputmask + value : null;

        this.context.setState({
            model,
            hasUnsavedChanges: true,
            facebookHasFocus: false
        });
        this.context.state.hasUnsavedChanges === true || this.context.props.setHasUnsavedChanges(true);
    }
}